<template lang="pug">
  b-modal(
    :id='modalId'
    :title='title'
    scrollable
    size="lg"
    hide-footer
    dialog-class="custom-dialog-position"
  )
    div.agreement-content
      p(v-html='content')
</template>

<script>
export default {
  name: 'dialogAgreement',
  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      required: true
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  color: #FFFFFF !important;
}

::v-deep .close {
  color: #FFFFFF;
  &:hover {
    color: #FFFFFF;
  }
}

.agreement-content {
  max-height: 60vh;
  overflow-y: auto;
  white-space: pre-line;
  padding-right: 10px;
}

::v-deep .modal {
  top: 5vh !important;
}

::v-deep .modal-content {
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.05);
}
</style>